export default "__VITE_ASSET__ihWFOY6Z__"